<! --
/**
* SuiteCRM is a customer relationship management program developed by SalesAgility Ltd.
* Copyright (C) 2024 SalesAgility Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SALESAGILITY, SALESAGILITY DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->

<div class="mobile-menu-container">
    <ng-container *ngIf="menuItems() && menuItems().length">
        <div class="mobile-menu-items scrollbar-thin">
            <li class="d-flex align-items-center" (click)="navigateRoute(item?.link?.route)" *ngFor="let item of menuItems()">
                <scrm-image class="sicon mobile-nav-icon pl-3" [image]="item.icon"
               ></scrm-image>
                <a class="flex-grow-1 mobile-nav-link px-3 py-2 mobile-menu-item-label">{{ item.link.label }}</a>
            </li>
        </div>
    </ng-container>

    <li class="border-0">
        <div *ngIf="!menuItems() || !menuItems()?.length" class="d-flex justify-content-center">
            <scrm-label [labelKey]="'LBL_MODULE_NOT_FOUND'"></scrm-label>
        </div>
    </li>
</div>


